import COM_API from '@/api/masterData/company.js';
export const searchColumns = (ctx) => {
  return [
    {
      name: '合同编号',
      prop: 'contractNo',
      type: 'input',
    },
    {
      name: '合同名称',
      prop: 'contractName',
      type: 'input',
    },
    {
      name: '项目名称',
      prop: 'projectName',
      searchType: 'projectListWumao',
      type: 'searchTableSpec',
      isMultiple: true,
      extraData: {
        projectInitiationStatusList: ['PIS04', 'PIS05', 'PIS07', 'PIS08'],
        applyCompanyName: ctx.userInfo.companyName,
        platformtCompanyName: ctx.userInfo.companyName,
        recyclingtCompanyName: ctx.userInfo.companyName,
      },
    },
    {
      name: '客户名称',
      prop: 'customerName',
      type: 'searchTableSpec',
      searchType: 'partner',
      extraData: {
        partnerTypes: 'HZHB01,HZHB03,HZHB11,HZHB10',
        departmentCode: ctx.userInfo.departmentCode,
        companyCode: ctx.userInfo.companyNo, //选择公司后的客户名称
      },
      isMultiple: true,
    },
    {
      name: '供应商名称',
      prop: 'supplierNo',
      type: 'searchTableSpec',
      searchType: 'supplier',
      extraData: {
        departmentCode: ctx.userInfo.departmentCode,
        companyCode: ctx.userInfo.companyNo, //选择公司后的客户名称
      },
      isMultiple: true,
    },
    {
      name: '业务部门',
      prop: 'departmentCode',
      type: 'treeSelect',
      apiUrl: COM_API.LIST_COMPANY_API,
      apiData: {
        tenantCode: ctx.userInfo.tenantCode,
        adminFlag: ctx.userInfo.adminFlag,
      },
      multiple: true,
      clearable: false,
      filterData: (data) => {
        const departmentList = ctx.userInfo.allDepartmentList.map((v) => v.personDepartmentCode);
        const companyList = JSON.parse(ctx.userInfo.companyList).map((v) => v.personCompanyCode);
        const filterCompanyData = data.filter((v) => companyList.includes(v.id));
        const filterFun = (list) => {
          if (!list) return list;
          if (list.children && list.children.length) {
            return list.map((v) => {
              v.children = filterFun(v.children);
              return v;
            });
          } else return list.filter((v) => departmentList.includes(v.id));
        };
        return filterCompanyData.map((v) => {
          v.children = filterFun(v.children);
          return v;
        });
      },
    },
    {
      name: '单据状态',
      prop: 'contractStatus',
      type: 'dict',
      dictType: 'contract_status_wm',
    },
  ];
};

export const defaultTableColumns = [
  {
    field: 'contractNo',
    title: '合同编号',
    width: '140',
  },
  {
    field: 'contractName',
    title: '合同名称',
    width: '140',
  },
  {
    field: 'contractStatus',
    title: '单据状态',
    width: '140',
  },
  {
    field: 'contractBusinessCompanyName',
    title: '公司',
    width: '140',
  },
  {
    field: 'contractBusinessDepartmentName',
    title: '业务部门',
    width: '140',
  },
  {
    field: 'projectInitiationNo',
    title: '项目编号',
    width: '140',
  },
  {
    field: 'projectName',
    title: '项目名称',
    width: '140',
  },
  {
    field: 'supplierName',
    title: '供应商名称',
    width: '140',
  },
  {
    field: 'customerName',
    title: '客户名称',
    width: '140',
  },
  {
    field: 'contractOperaterName',
    title: '经办人',
    width: '140',
  },
  {
    field: 'contractSalesmanName',
    title: '部门负责人',
    width: '140',
  },
  {
    field: 'signDate',
    title: '合同签署日期',
    width: '140',
  },
  {
    field: 'contractValidStart',
    title: '合同生效日期',
    width: '140',
  },
  {
    field: 'contractValidEnd',
    title: '合同到期日期',
    width: '140',
  },
  {
    field: 'purchaseQuantity',
    title: '合同数量',
    width: '140',
  },
  {
    field: 'incomeMethod',
    title: '收益方式',
    width: '140',
  },
  {
    field: 'replyInvoiceDate',
    title: '回票日期',
    width: '140',
  },
  {
    field: 'isDefault',
    title: '是否有违约责任',
    width: '140',
  },
  {
    field: 'liquidatedDamagesType',
    title: '合同违约金类型',
    width: '140',
  },
  {
    field: 'liquidatedFixedValue',
    title: '违约金固定值',
    width: '140',
  },
  {
    field: 'liquidatedInterestRate',
    title: '违约金日利率',
    width: '140',
  },
  {
    field: 'overShippedPercentage',
    title: '溢装比例',
    width: '140',
  },
  {
    field: 'shortShippedPercentage',
    title: '短装比例',
    width: '140',
  },
  {
    field: 'cgExternalContractNo',
    title: '外部合同号（采购端）',
    width: '140',
  },
  {
    field: 'lastestPayMoneyDay',
    title: '最晚付款日',
    width: '140',
  },
  {
    field: 'lastestReceiveProductDay',
    title: '最晚收货日',
    width: '140',
  },
  {
    field: 'isPrepay',
    title: '预付',
    width: '140',
  },
  {
    field: 'creditAmount',
    title: '预付金额',
    width: '140',
  },
  {
    field: 'cgReceiptMethod',
    title: '付款方式',
    width: '140',
  },
  {
    field: 'cgContractCurrency',
    title: '采购货币',
    width: '140',
  },
  {
    field: 'ssExternalContractNo',
    title: '外部合同号（销售端）',
    width: '140',
  },
  {
    field: 'overduePeriod',
    title: '逾期周期',
    width: '140',
  },
  {
    field: 'settlementDate',
    title: '结算日',
    width: '140',
  },
  {
    field: 'qualityGuaranteeDepositMethodCode',
    title: '质保金收取方式',
    width: '140',
  },
  {
    field: 'chargeFixedValue',
    title: '收取固定值',
    width: '140',
  },
  {
    field: 'chargeProportion',
    title: '收取比例',
    width: '140',
  },
  {
    field: 'qualityGuaranteeDepositOverdue',
    title: '质保金逾期期限',
    width: '140',
  },
  {
    field: 'marginAmount',
    title: '保证金',
    width: '140',
  },
  {
    field: 'ssReceiptMethod',
    title: '收款方式',
    width: '140',
  },
  {
    field: 'ssContractCurrency',
    title: '销售货币',
    width: '140',
  },
  {
    field: 'isRestrict',
    title: '是否定量',
    width: '140',
  },
  {
    field: 'productDesc',
    title: '商品描述',
    width: '140',
  },
  {
    field: 'productQuantity',
    title: '合同数量',
    width: '140',
  },
  {
    title: '是否长期合同',
    field: 'isLongRange',
  },
];
